import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { StateSwitcher } from '@/components/atoms/state-switcher'
import PageHeader from '@/components/molecules/page-header'
import IndividualInfoCard from '@/components/organisms/home/individual-info-card'
import { InviteIndividualCard } from '@/components/organisms/home/invite-individual-card'
import { IndividualType, useIndividuals } from '@/hooks/useIndividuals'

const IndividualPage = () => {
  const { individualQuery, selectedIndividual } = useIndividuals()

  return (
    <StateSwitcher isLoading={individualQuery.isLoading && !selectedIndividual}>
      {selectedIndividual && <IndividualContent individual={selectedIndividual} />}
    </StateSwitcher>
  )
}

const IndividualContent = ({ individual }: { individual: IndividualType }) => {
  const { t } = useTranslation()

  return (
    <div className="max-w-6xl space-y-10">
      <PageHeader
        body={t('individualPage.description', { name: individual.firstName })}
        heading={t('individualPage.heading', { name: individual.firstName })}
      />
      <IndividualInfoCard individual={individual} />
      <InviteIndividualCard individual={individual} />
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/individual')({
  component: IndividualPage,
})
